import { Loader2 } from 'lucide-react';

import { useGetPushScenarios } from '~entities/mobile-inventor-push/api/get-push-scenarios';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';

import { PushScenarioToggleCard } from './push-scenario-toggle-card';

export const PushAutomatedScenariosSection = () => {
  const { data, isLoading, isError } = useGetPushScenarios();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Automated notifications</CardTitle>
        <CardDescription>
          Control which event-driven push notifications are sent automatically
          from Enrollio.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className='flex justify-center py-8'>
            <Loader2 className='size-8 animate-spin' />
          </div>
        ) : null}
        {isError ? (
          <p className='text-sm text-destructive'>
            Failed to load automated notification settings.
          </p>
        ) : null}
        {!isLoading && !isError ? (
          <div className='grid gap-4 md:grid-cols-2'>
            {(data?.scenarios ?? []).map((toggle) => (
              <PushScenarioToggleCard key={toggle.name} toggle={toggle} />
            ))}
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
};
